<p-card class="crew-card" [ngClass]="{'grayOverlay': workOrder.completionStatus == 'Completed' || workOrder.completionStatus =='Unable to be Completed'}" (click)="dblclickHandler()">
  <p-header class="container">
    <div class="wo-header row">
      <div class="zip-code col-6"
        [style.background]="(workOrder.address && workOrder.address.geoColor) ? workOrder.address.geoColor : ''"
        [style.color]="(workOrder.address && workOrder.address.textColor) ? workOrder.address.textColor : ''">
        {{workOrder.address.zip}}
      </div>
      <div class="status col-6" (mouseenter)="datePanel.toggle($event)" (mouseleave)="datePanel.toggle($event)"
        [style.background]="getPriorityBackgroundColor()"
        [style.color]="getPriorityColor()">
        {{workOrder.mostUrgentPriorityLevel?.status}}
        <p-popover #datePanel [appendTo]="'body'">
          <div>
            {{workOrder.mostUrgentPriorityLevel?.status}}
          </div>
          @if (workOrder.completionStatus != 'Completed' && workOrder.completionStatus !='Unable to be Completed') {
            <div>
              @for (task of tasks; track task) {
                <div>
                  {{getDueDateDisplay(task)}}
                </div>
              }
            </div>
          }
        </p-popover>
      </div>
    </div>
  </p-header>

  <div style="padding: 8px 0 14px;">
    <div class="center">
      <p><a [routerLink]="" (click)="navigateToWorkOrder()" class="blue-link">{{workOrder.quoteNumber}}</a></p>
    </div>
    <div class="center">
      <p>{{customCustomerService.getCustomerFullName(workOrder.customer)}}</p>
      @if (hasCompanyWideNotes) {
        <i class="fa fa-sticky-note" (click)="op.toggle($event)"></i>
      }
      <p-popover #op [appendTo]="'body'">
        <app-customer-comment-view-only [customer]="workOrder.customer"></app-customer-comment-view-only>
      </p-popover>
    </div>

    <div class="center equipment-type">
      {{ getEquipmentTypeDisplay() ? getEquipmentTypeDisplay() : 'No equipment' }}
    </div>
  </div>

  <div class="p-grid">
    <div class="p-col">
      <p-datepicker [(ngModel)]="bigDayBucket.fromDate" class="secondary" [style]="{'width':'100%'}"
        [inputStyle]="{'width':'100%'}" [maxDate]="bigDayBucket.toDate"
        [appDateLessThanAllSubrangeValidator]="bigDayBucketSubranges" appendTo="body">
      </p-datepicker>
    </div>
    <div class="p-col-1 to">
      to
    </div>
    <div class="p-col">
      <p-datepicker [(ngModel)]="bigDayBucket.toDate" class="secondary leftThis" [style]="{'width':'100%'}"
        [inputStyle]="{'width':'100%'}" [minDate]="bigDayBucket.fromDate"
      [appDateGreaterThanAllSubrangeValidator]="bigDayBucketSubranges" appendTo="body"></p-datepicker>
    </div>
  </div>

  <div class="toggle-tasks">
    <div style="text-align: right;">
      <span class="point" (click)="isCollapsed = !isCollapsed; letLoad()" [attr.aria-expanded]="!isCollapsed" class="plus-minus-span">
        {{isCollapsed ? '+' : '-'}}
      </span>
    </div>  
    <div [ngbCollapse]="isCollapsed" class="crew-work-orders" style="transition: all 300ms cubic-bezier(1, 0, 0, 1);">
      <div class="p-col-12 clearfix">
        <p-button severity="success" class="float-right" label="Add New" (click)="onAddSubrange()"></p-button>
      </div>
      <div>
        <div style="text-align: center;">
          <app-loading-swirly [isLoading]="isLoading"></app-loading-swirly>
        </div>
        @if(!isLoading){
        @for (subrange of bigDayBucketSubranges; track subrange) {
        <div class="inner-card">
          <app-multiday-subrange-card [bigDayBucketSubrange]="subrange" [bigDayBucket]="bigDayBucket"
            (deleted)="deleteSubrange($event)">
          </app-multiday-subrange-card>
          <br>
        </div>
        }
        }

        @if (bigDayBucketSubranges && bigDayBucketSubranges.length == 0) {
          <div class="inner-card drag-placeholder">
            <p-card>Add a Subrange</p-card>
          </div>
        }
      </div>
    </div>
  </div>

  <p-footer>
    <div class="clearfix">
      <p-button type="button" label="Save" [disabled]="isSaving"
      class="float-right" (click)="saveAll()"></p-button>
    </div>
  </p-footer>
</p-card>
